"use strict";

exports.__esModule = true;
exports.default = equals;
function equals(comparisonOld, comparisonNew) {
  if (comparisonOld === undefined || comparisonNew === undefined) {
    return false;
  }

  return comparisonNew === comparisonOld;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/equals.js
// module id = 687
// module chunks = 0